import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueCompositionAPI from '@vue/composition-api'
import i18n from '@/libs/i18n' // Internationalization 国际化 多语言
// 自定义表格
import GtableCrud from '@/components/crud/index.vue'
// 自封装icon
import IconPark from '@/components/iconPark.vue'

import swal from 'vue-sweetalert2'

import router from './router'
import store from './store'
import App from './App.vue'
// 引入antd组件
// import 'ant-design-vue/dist/antd.css'
import './@core/lazy-load/index' // use lazy load components
// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
// import './permission' // 权限

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(ElementUI)
Vue.component('gtable-crud', GtableCrud)
Vue.component('icon-park', IconPark)

Vue.use(swal)

// Composition API
Vue.use(VueCompositionAPI)

require('@core/assets/fonts/feather/iconfont.css')

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false
// 日期格式化
Vue.filter('date', (v, format = 'DD MMM YYY') => (v ? moment(v).format(format) : ''))
Vue.filter('datetime', (v, format = 'hh:mm, DD MMM YYY') => (v ? moment(v).format(format) : ''))

const vue = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

export default vue
